/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VulnerabilityDefinitionEntity } from './VulnerabilityDefinitionEntity';
import {
    VulnerabilityDefinitionEntityFromJSON,
    VulnerabilityDefinitionEntityFromJSONTyped,
    VulnerabilityDefinitionEntityToJSON,
    VulnerabilityDefinitionEntityToJSONTyped,
} from './VulnerabilityDefinitionEntity';
import type { AssetResolutionStatus } from './AssetResolutionStatus';
import {
    AssetResolutionStatusFromJSON,
    AssetResolutionStatusFromJSONTyped,
    AssetResolutionStatusToJSON,
    AssetResolutionStatusToJSONTyped,
} from './AssetResolutionStatus';
import type { SystemBoundaryEntity } from './SystemBoundaryEntity';
import {
    SystemBoundaryEntityFromJSON,
    SystemBoundaryEntityFromJSONTyped,
    SystemBoundaryEntityToJSON,
    SystemBoundaryEntityToJSONTyped,
} from './SystemBoundaryEntity';
import type { VulnerabilityOwnership } from './VulnerabilityOwnership';
import {
    VulnerabilityOwnershipFromJSON,
    VulnerabilityOwnershipFromJSONTyped,
    VulnerabilityOwnershipToJSON,
    VulnerabilityOwnershipToJSONTyped,
} from './VulnerabilityOwnership';

/**
 * Vulnerability data
 * @export
 * @interface VulnerabilityInstanceEntity
 */
export interface VulnerabilityInstanceEntity {
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityInstanceEntity
     */
    discoveredAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityInstanceEntity
     */
    lastSeenAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityInstanceEntity
     */
    decommissionedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    sourceRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    status?: VulnerabilityInstanceEntityStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof VulnerabilityInstanceEntity
     */
    version?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof VulnerabilityInstanceEntity
     */
    extendedAttributes?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityInstanceEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityInstanceEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    goldenRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    assetGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    assetClass?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VulnerabilityInstanceEntity
     */
    kevListed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    findingState?: VulnerabilityInstanceEntityFindingStateEnum;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    stateSource?: VulnerabilityInstanceEntityStateSourceEnum;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityInstanceEntity
     */
    stateChangedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    stateChangedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    exceptionId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VulnerabilityInstanceEntity
     */
    vendorDisputed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    severityOverride?: VulnerabilityInstanceEntitySeverityOverrideEnum;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    severityOverrideReason?: string;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityInstanceEntity
     */
    lastRemediatedAt?: Date;
    /**
     * 
     * @type {VulnerabilityDefinitionEntity}
     * @memberof VulnerabilityInstanceEntity
     */
    vulnerabilityDefinition?: VulnerabilityDefinitionEntity;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    cveId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VulnerabilityInstanceEntity
     */
    assetIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof VulnerabilityInstanceEntity
     */
    containerIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    resolutionStatus?: VulnerabilityInstanceEntityResolutionStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityInstanceEntity
     */
    resolvedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    resolutionMethod?: VulnerabilityInstanceEntityResolutionMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    resolutionNotes?: string;
    /**
     * 
     * @type {{ [key: string]: AssetResolutionStatus; }}
     * @memberof VulnerabilityInstanceEntity
     */
    assetResolutionStatus?: { [key: string]: AssetResolutionStatus; };
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    assignedTo?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    assignedToEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    assignedToType?: VulnerabilityInstanceEntityAssignedToTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    assignedBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityInstanceEntity
     */
    assignedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    assignmentReason?: string;
    /**
     * 
     * @type {VulnerabilityOwnership}
     * @memberof VulnerabilityInstanceEntity
     */
    ownership?: VulnerabilityOwnership;
    /**
     * 
     * @type {number}
     * @memberof VulnerabilityInstanceEntity
     */
    priorityScore?: number;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    priorityLevel?: VulnerabilityInstanceEntityPriorityLevelEnum;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityInstanceEntity
     */
    priorityCalculatedAt?: Date;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof VulnerabilityInstanceEntity
     */
    prioritizationFactors?: { [key: string]: any; };
    /**
     * 
     * @type {Set<SystemBoundaryEntity>}
     * @memberof VulnerabilityInstanceEntity
     */
    affectedBoundaries?: Set<SystemBoundaryEntity>;
    /**
     * 
     * @type {boolean}
     * @memberof VulnerabilityInstanceEntity
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VulnerabilityInstanceEntity
     */
    decommissioned?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityInstanceEntity
     */
    effectTenantId?: string;
}


/**
 * @export
 */
export const VulnerabilityInstanceEntityStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Decommissioned: 'DECOMMISSIONED',
    Deleted: 'DELETED'
} as const;
export type VulnerabilityInstanceEntityStatusEnum = typeof VulnerabilityInstanceEntityStatusEnum[keyof typeof VulnerabilityInstanceEntityStatusEnum];

/**
 * @export
 */
export const VulnerabilityInstanceEntityFindingStateEnum = {
    Open: 'OPEN',
    Remediated: 'REMEDIATED',
    FalsePositive: 'FALSE_POSITIVE',
    RiskAccepted: 'RISK_ACCEPTED',
    Exception: 'EXCEPTION',
    Superseded: 'SUPERSEDED',
    RemediationPending: 'REMEDIATION_PENDING'
} as const;
export type VulnerabilityInstanceEntityFindingStateEnum = typeof VulnerabilityInstanceEntityFindingStateEnum[keyof typeof VulnerabilityInstanceEntityFindingStateEnum];

/**
 * @export
 */
export const VulnerabilityInstanceEntityStateSourceEnum = {
    Scanner: 'SCANNER',
    Analyst: 'ANALYST',
    Policy: 'POLICY',
    System: 'SYSTEM'
} as const;
export type VulnerabilityInstanceEntityStateSourceEnum = typeof VulnerabilityInstanceEntityStateSourceEnum[keyof typeof VulnerabilityInstanceEntityStateSourceEnum];

/**
 * @export
 */
export const VulnerabilityInstanceEntitySeverityOverrideEnum = {
    Critical: 'CRITICAL',
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
    Info: 'INFO'
} as const;
export type VulnerabilityInstanceEntitySeverityOverrideEnum = typeof VulnerabilityInstanceEntitySeverityOverrideEnum[keyof typeof VulnerabilityInstanceEntitySeverityOverrideEnum];

/**
 * @export
 */
export const VulnerabilityInstanceEntityResolutionStatusEnum = {
    Unresolved: 'UNRESOLVED',
    PartiallyResolved: 'PARTIALLY_RESOLVED',
    Resolved: 'RESOLVED'
} as const;
export type VulnerabilityInstanceEntityResolutionStatusEnum = typeof VulnerabilityInstanceEntityResolutionStatusEnum[keyof typeof VulnerabilityInstanceEntityResolutionStatusEnum];

/**
 * @export
 */
export const VulnerabilityInstanceEntityResolutionMethodEnum = {
    Patched: 'PATCHED',
    WorkaroundApplied: 'WORKAROUND_APPLIED',
    AssetDecommissioned: 'ASSET_DECOMMISSIONED',
    FalsePositive: 'FALSE_POSITIVE',
    ConfigurationChange: 'CONFIGURATION_CHANGE'
} as const;
export type VulnerabilityInstanceEntityResolutionMethodEnum = typeof VulnerabilityInstanceEntityResolutionMethodEnum[keyof typeof VulnerabilityInstanceEntityResolutionMethodEnum];

/**
 * @export
 */
export const VulnerabilityInstanceEntityAssignedToTypeEnum = {
    Individual: 'INDIVIDUAL',
    Team: 'TEAM',
    Group: 'GROUP'
} as const;
export type VulnerabilityInstanceEntityAssignedToTypeEnum = typeof VulnerabilityInstanceEntityAssignedToTypeEnum[keyof typeof VulnerabilityInstanceEntityAssignedToTypeEnum];

/**
 * @export
 */
export const VulnerabilityInstanceEntityPriorityLevelEnum = {
    Critical: 'CRITICAL',
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
    Unknown: 'UNKNOWN'
} as const;
export type VulnerabilityInstanceEntityPriorityLevelEnum = typeof VulnerabilityInstanceEntityPriorityLevelEnum[keyof typeof VulnerabilityInstanceEntityPriorityLevelEnum];


/**
 * Check if a given object implements the VulnerabilityInstanceEntity interface.
 */
export function instanceOfVulnerabilityInstanceEntity(value: object): value is VulnerabilityInstanceEntity {
    return true;
}

export function VulnerabilityInstanceEntityFromJSON(json: any): VulnerabilityInstanceEntity {
    return VulnerabilityInstanceEntityFromJSONTyped(json, false);
}

export function VulnerabilityInstanceEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): VulnerabilityInstanceEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'discoveredAt': json['discoveredAt'] == null ? undefined : (new Date(json['discoveredAt'])),
        'lastSeenAt': json['lastSeenAt'] == null ? undefined : (new Date(json['lastSeenAt'])),
        'decommissionedAt': json['decommissionedAt'] == null ? undefined : (new Date(json['decommissionedAt'])),
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'sourceRecordId': json['sourceRecordId'] == null ? undefined : json['sourceRecordId'],
        'status': json['status'] == null ? undefined : json['status'],
        'version': json['version'] == null ? undefined : json['version'],
        'extendedAttributes': json['extendedAttributes'] == null ? undefined : json['extendedAttributes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'goldenRecordId': json['goldenRecordId'] == null ? undefined : json['goldenRecordId'],
        'assetGoldenId': json['assetGoldenId'] == null ? undefined : json['assetGoldenId'],
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'kevListed': json['kevListed'] == null ? undefined : json['kevListed'],
        'findingState': json['findingState'] == null ? undefined : json['findingState'],
        'stateSource': json['stateSource'] == null ? undefined : json['stateSource'],
        'stateChangedAt': json['stateChangedAt'] == null ? undefined : (new Date(json['stateChangedAt'])),
        'stateChangedBy': json['stateChangedBy'] == null ? undefined : json['stateChangedBy'],
        'exceptionId': json['exceptionId'] == null ? undefined : json['exceptionId'],
        'vendorDisputed': json['vendorDisputed'] == null ? undefined : json['vendorDisputed'],
        'severityOverride': json['severityOverride'] == null ? undefined : json['severityOverride'],
        'severityOverrideReason': json['severityOverrideReason'] == null ? undefined : json['severityOverrideReason'],
        'lastRemediatedAt': json['lastRemediatedAt'] == null ? undefined : (new Date(json['lastRemediatedAt'])),
        'vulnerabilityDefinition': json['vulnerabilityDefinition'] == null ? undefined : VulnerabilityDefinitionEntityFromJSON(json['vulnerabilityDefinition']),
        'cveId': json['cveId'] == null ? undefined : json['cveId'],
        'assetIds': json['assetIds'] == null ? undefined : json['assetIds'],
        'containerIds': json['containerIds'] == null ? undefined : json['containerIds'],
        'resolutionStatus': json['resolutionStatus'] == null ? undefined : json['resolutionStatus'],
        'resolvedAt': json['resolvedAt'] == null ? undefined : (new Date(json['resolvedAt'])),
        'resolvedBy': json['resolvedBy'] == null ? undefined : json['resolvedBy'],
        'resolutionMethod': json['resolutionMethod'] == null ? undefined : json['resolutionMethod'],
        'resolutionNotes': json['resolutionNotes'] == null ? undefined : json['resolutionNotes'],
        'assetResolutionStatus': json['assetResolutionStatus'] == null ? undefined : (mapValues(json['assetResolutionStatus'], AssetResolutionStatusFromJSON)),
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
        'assignedToEmail': json['assignedToEmail'] == null ? undefined : json['assignedToEmail'],
        'assignedToType': json['assignedToType'] == null ? undefined : json['assignedToType'],
        'assignedBy': json['assignedBy'] == null ? undefined : json['assignedBy'],
        'assignedAt': json['assignedAt'] == null ? undefined : (new Date(json['assignedAt'])),
        'assignmentReason': json['assignmentReason'] == null ? undefined : json['assignmentReason'],
        'ownership': json['ownership'] == null ? undefined : VulnerabilityOwnershipFromJSON(json['ownership']),
        'priorityScore': json['priorityScore'] == null ? undefined : json['priorityScore'],
        'priorityLevel': json['priorityLevel'] == null ? undefined : json['priorityLevel'],
        'priorityCalculatedAt': json['priorityCalculatedAt'] == null ? undefined : (new Date(json['priorityCalculatedAt'])),
        'prioritizationFactors': json['prioritizationFactors'] == null ? undefined : json['prioritizationFactors'],
        'affectedBoundaries': json['affectedBoundaries'] == null ? undefined : (new Set((json['affectedBoundaries'] as Array<any>).map(SystemBoundaryEntityFromJSON))),
        'active': json['active'] == null ? undefined : json['active'],
        'decommissioned': json['decommissioned'] == null ? undefined : json['decommissioned'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function VulnerabilityInstanceEntityToJSON(json: any): VulnerabilityInstanceEntity {
    return VulnerabilityInstanceEntityToJSONTyped(json, false);
}

export function VulnerabilityInstanceEntityToJSONTyped(value?: VulnerabilityInstanceEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'discoveredAt': value['discoveredAt'] == null ? undefined : ((value['discoveredAt']).toISOString()),
        'lastSeenAt': value['lastSeenAt'] == null ? undefined : ((value['lastSeenAt']).toISOString()),
        'decommissionedAt': value['decommissionedAt'] == null ? undefined : ((value['decommissionedAt']).toISOString()),
        'sourceSystem': value['sourceSystem'],
        'sourceRecordId': value['sourceRecordId'],
        'status': value['status'],
        'version': value['version'],
        'extendedAttributes': value['extendedAttributes'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'goldenRecordId': value['goldenRecordId'],
        'assetGoldenId': value['assetGoldenId'],
        'assetClass': value['assetClass'],
        'kevListed': value['kevListed'],
        'findingState': value['findingState'],
        'stateSource': value['stateSource'],
        'stateChangedAt': value['stateChangedAt'] == null ? undefined : ((value['stateChangedAt']).toISOString()),
        'stateChangedBy': value['stateChangedBy'],
        'exceptionId': value['exceptionId'],
        'vendorDisputed': value['vendorDisputed'],
        'severityOverride': value['severityOverride'],
        'severityOverrideReason': value['severityOverrideReason'],
        'lastRemediatedAt': value['lastRemediatedAt'] == null ? undefined : ((value['lastRemediatedAt']).toISOString()),
        'vulnerabilityDefinition': VulnerabilityDefinitionEntityToJSON(value['vulnerabilityDefinition']),
        'cveId': value['cveId'],
        'assetIds': value['assetIds'],
        'containerIds': value['containerIds'],
        'resolutionStatus': value['resolutionStatus'],
        'resolvedAt': value['resolvedAt'] == null ? undefined : ((value['resolvedAt']).toISOString()),
        'resolvedBy': value['resolvedBy'],
        'resolutionMethod': value['resolutionMethod'],
        'resolutionNotes': value['resolutionNotes'],
        'assetResolutionStatus': value['assetResolutionStatus'] == null ? undefined : (mapValues(value['assetResolutionStatus'], AssetResolutionStatusToJSON)),
        'assignedTo': value['assignedTo'],
        'assignedToEmail': value['assignedToEmail'],
        'assignedToType': value['assignedToType'],
        'assignedBy': value['assignedBy'],
        'assignedAt': value['assignedAt'] == null ? undefined : ((value['assignedAt']).toISOString()),
        'assignmentReason': value['assignmentReason'],
        'ownership': VulnerabilityOwnershipToJSON(value['ownership']),
        'priorityScore': value['priorityScore'],
        'priorityLevel': value['priorityLevel'],
        'priorityCalculatedAt': value['priorityCalculatedAt'] == null ? undefined : ((value['priorityCalculatedAt']).toISOString()),
        'prioritizationFactors': value['prioritizationFactors'],
        'affectedBoundaries': value['affectedBoundaries'] == null ? undefined : (Array.from(value['affectedBoundaries'] as Set<any>).map(SystemBoundaryEntityToJSON)),
        'active': value['active'],
        'decommissioned': value['decommissioned'],
        'effectTenantId': value['effectTenantId'],
    };
}

